import { PostType } from '@tribeplatform/gql-client/types'

// Archived reply types are rejected by the backend on createReply, so they must
// never be offered — otherwise the reply UI renders an affordance that always fails.
export const selectableReplyTypes = (
  replyTypes: PostType[] | undefined | null,
): PostType[] => replyTypes?.filter(replyType => !replyType.archived) ?? []

export const hasSelectableReplyType = (
  replyTypes: PostType[] | undefined | null,
): boolean => replyTypes?.some(replyType => !replyType.archived) ?? false
